import { render, staticRenderFns } from "./ShoppingDetailsModal.vue?vue&type=template&id=2d0604b8&scoped=true&"
import script from "./ShoppingDetailsModal.vue?vue&type=script&lang=js&"
export * from "./ShoppingDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0604b8",
  null
  
)

export default component.exports